import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import cloneObject from '../functions/clone.object';
import createGuid from '../functions/create.guid';
import useTrait from '../hooks/use.trait';
import Div from './div';

const H1 = props => {
   const [id] = useState(props.id ? props.id : createGuid());
   const hasBeenFocused = useTrait(false);
   
   useEffect(() => {
      if (hasBeenFocused.get())
         return;
      document.getElementById(id).focus();
      hasBeenFocused.set(true);
   });
   
   const clonedProps = cloneObject(props);
   delete clonedProps.id;
   
   return <>
      <Div
         paddingBottom={2}
         paddingTop={5} paddingTopMD={3}
      >
         <h1
            className={'ds-h1'}
            id={id}
            tabIndex={-1}
            {...clonedProps}
         >{props.children}</h1>
      </Div>
   </>;
};

H1.propTypes = {
   id: PropTypes.string,
};

H1.defaultProps = {
   id: '',
};

export default H1; 